import React from 'react';

const FormGroup = (props: { children: React.ReactNode }) => {
  return (
    <div style={{ paddingTop: 10, paddingBottom: 10 }}>{props.children}</div>
  );
};

export { FormGroup };
